export default {
    authUrl: "#{authUrl}#",
}